var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { COLORS } from '../../../themes';
var DropdownIndicatorContainer = styled(FontAwesomeIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  color: ", ";\n  font-size: 14px;\n  margin-right: 8px;\n"], ["\n  display: block;\n  color: ", ";\n  font-size: 14px;\n  margin-right: 8px;\n"])), COLORS.archive);
// eslint-disable-next-line react/display-name
var DropdownIndicator = function (icon) { return function () {
    return _jsx(DropdownIndicatorContainer, { icon: icon });
}; };
var customStyles = function (_a) {
    var overridePortalPosition = _a.overridePortalPosition, top = _a.top, left = _a.left, apppexStyle = _a.apppexStyle, minHeight = _a.minHeight, height = _a.height, width = _a.width, placeHolderColor = _a.placeHolderColor, selectedBgColor = _a.selectedBgColor, controlBorderColor = _a.controlBorderColor, controlFocusedBorderColor = _a.controlFocusedBorderColor, shadowNotVisible = _a.shadowNotVisible, isRoundedChips = _a.isRoundedChips;
    return (__assign(__assign(__assign(__assign({ menu: function (provided, state) {
            var _a;
            return (__assign(__assign({}, provided), { zIndex: 100, width: ((_a = state === null || state === void 0 ? void 0 : state.selectProps) === null || _a === void 0 ? void 0 : _a.width) ? state.selectProps.width : '100%' }));
        }, container: function (provided) { return (__assign(__assign({}, provided), { flex: '1', border: 'none', boxShadow: 'none' })); }, valueContainer: function (provided) { return (__assign({}, provided)); }, input: function (provided) { return (__assign({}, provided)); } }, (overridePortalPosition
        ? {
            menuPortal: function (provided) { return (__assign(__assign({}, provided), { position: 'absolute', top: top, left: left, zIndex: 9999 })); },
        }
        : {})), { groupHeading: function (provided) { return (__assign(__assign({}, provided), { textTransform: 'uppercase', fontSize: '11px', color: '#212121', fontWeight: '600', paddingTop: '8px', paddingBottom: '4px', borderBottom: '1px solid #dedede' })); }, group: function (provided) { return (__assign(__assign({}, provided), { marginLeft: '0' })); }, option: function (provided, state) { return (__assign(__assign({}, provided), { background: (state.isSelected && selectedBgColor) ||
                (state.isFocused && '#ededed') ||
                'transparent', color: state.isSelected || state.isFocused ? '#212121' : '#858585', fontWeight: state.isSelected ? '400' : '400', fontSize: '16px', textOverflow: 'ellipsis', overflow: 'hidden', flexWrap: 'nowrap' })); } }), (apppexStyle
        ? {
            control: function (provided, state) { return (__assign(__assign({}, provided), { fontSize: '16px', border: state.isFocused ? '1px solid #36E0B7' : '1px solid #07285b', boxShadow: state.isFocused ? '0 0 0 1px #36E0B7' : 'none', outline: 'none', width: width, '&:hover': {
                    border: '1px solid #36E0B7',
                    boxShadow: '0 0 0 1px #36E0B7',
                } })); },
        }
        : {
            control: function (provided, state) { return (__assign(__assign({}, provided), { fontSize: '16px', lineHeight: '16px', border: state.isFocused
                    ? "1px solid ".concat(controlFocusedBorderColor)
                    : "1px solid ".concat(controlBorderColor), boxShadow: !state.isFocused || shadowNotVisible
                    ? 'none'
                    : "0 0 0 1px ".concat(controlFocusedBorderColor), outline: 'none', '&:hover': {
                    border: "1px solid ".concat(controlFocusedBorderColor),
                    boxShadow: shadowNotVisible
                        ? 'none'
                        : "0 0 0 1px ".concat(controlFocusedBorderColor),
                }, minHeight: minHeight, height: height, width: width })); },
        })), { indicatorSeparator: function (provided) { return (__assign(__assign({}, provided), { background: 'none' })); }, indicatorsContainer: function (provided) { return (__assign({}, provided)); }, singleValue: function (provided, state) { return (__assign(__assign({}, provided), { opacity: state.isDisabled ? 0.5 : 1, transition: 'opacity 300ms', textOverflow: 'ellipsis', overflow: 'hidden', flexWrap: 'nowrap' })); }, placeholder: function (defaultStyles, state) {
            return __assign(__assign({}, defaultStyles), { color: placeHolderColor, opacity: state.isDisabled ? 0.5 : 1 });
        }, multiValue: function (styles) {
            return isRoundedChips
                ? {
                    borderRadius: '16px',
                    border: '1px solid #C2C2C2',
                    backgroundColor: '#E9E9E9',
                    display: 'flex',
                    padding: '4px 8px 4px 8px',
                    marginRight: '8px',
                    gap: '8px',
                }
                : styles;
        }, multiValueLabel: function (styles) {
            return isRoundedChips
                ? {
                    color: '#828282',
                }
                : styles;
        }, multiValueRemove: function (styles) {
            return isRoundedChips
                ? {
                    color: ' #C2C2C2',
                    height: '16px',
                }
                : styles;
        } }));
};
var appNode = document.getElementById('app');
var CustomSelect = function (props) {
    var _a = (props.menuPortalTarget &&
        props.menuPortalTarget) || { offsetTop: 0, offsetLeft: 0 }, offsetTop = _a.offsetTop, offsetLeft = _a.offsetLeft;
    var _b = props.style, style = _b === void 0 ? {} : _b, apppexStyle = props.apppexStyle, rest = __rest(props, ["style", "apppexStyle"]);
    return (_jsx("div", __assign({ id: "select", style: style }, { children: _jsx(Select, __assign({}, rest, { width: props.width || '100%', value: props.value, menuPortalTarget: props.menuPortalTarget || appNode, menuPlacement: props.menuPlacement || 'auto', styles: customStyles({
                overridePortalPosition: !!props.menuPortalTarget,
                top: offsetTop + 38,
                left: offsetLeft,
                apppexStyle: apppexStyle,
                minHeight: props.minHeight || 'auto',
                height: props.height || 'auto',
                width: props.width || 'auto',
                placeHolderColor: props.placeHolderColor,
                selectedBgColor: props.selectedBgColor || '#36E0B7',
                controlBorderColor: props.controlBorderColor || '#c2c2c2',
                controlFocusedBorderColor: props.controlFocusedBorderColor || '#36E0B7',
                shadowNotVisible: props.controlFocusedBorderColor,
                isRoundedChips: props.isRoundedChips,
            }), components: __assign({ DropdownIndicator: DropdownIndicator(faChevronDown) }, props.components) })) })));
};
export default CustomSelect;
var templateObject_1;
